<template>
    <div class="w-100 h-100">
        <b-modal
            v-model="showModal"
            hide-header
            hide-header-close
            title="Data Submitted"
            centered
            @ok="clearFields"
        >
            <div class="text-center">
                <div>{{ModalMessage}}</div>
            </div>
        </b-modal>
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">Product Bag Summary</h2>
            <p class="tw-italic tw-text-gray-700">
                Summary of product bag status
            </p>
        </b-container>
        <br />
        <b-row>
            <b-col cols="4">
                <b-form-group
                    id="fieldset-7"
                    label="Product Bag Barcode"
                    label-for="search_keyword"
                >
                    <b-input-group>
                        <b-form-input
                            id="search_keyword"
                            v-model="search_keyword"
                            trim v-on:keydown.enter="updateTable"
                            placeholder="Search for Product Bag Barcode..."
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button variant="success" @click="updateTable"><i class="fa fa-search"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="3">
                <label for="start_date">Start Date</label>
                <b-form-datepicker
                id="start_date"
                v-model="start_date"
                placeholder="Start Date"
                class="mb-2"
                reset-button
                >
                </b-form-datepicker>
            </b-col>
            <b-col lg="3">
                <label for="end_date">End Date</label>
                <b-form-datepicker
                    id="end_date"
                    :min="start_date"
                    v-model="end_date"
                    placeholder="End Date"
                    class="mb-2"
                    reset-button
                    :disabled='start_date==""'
                >
                </b-form-datepicker>
            </b-col>
            <b-col cols="2" align-self="end">
                <b-button style="width: 90px;" class="mb-3" @click="clearFields">
                    Clear
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>Total Results: {{ totalRows }} 
                    <i v-if="!csvLoading" @click="downloadFile" class="fa fa-download text-success" style="margin-left: 10px; cursor: pointer;" title="Download All"></i>
                    <i v-if="csvLoading" class="fa fa-spinner fa-spin text-primary" style="margin-left: 10px;" title="Downloading..."></i>
                </small>
            </b-col>
        </b-row>
        <div style="width: 100%; overflow: auto;">
            <b-table
                ref="resultTable"
                striped
                hover
                selectable
                select-mode='single'
                @row-selected="onRowSelected"
                :fields="fields"
                :items="getData"
                :current-page="currentPage"
                :per-page="perPage"
                :tbody-tr-class="'clickable'"
                :busy.sync="tableBusy"
            >
            <!-- :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
            -->
                <!-- Replace rows with a busy spinner while the table data is loading. -->
                <!-- https://bootstrap-vue.org/docs/components/table#table-busy-state -->
                <template #table-busy>
                <div class="text-danger my-2">
                    <b-spinner></b-spinner>
                    <strong>&nbsp;Loading...</strong>
                </div>
                </template>
            </b-table>
        </div>

        <b-row>
            <b-col cols="2">
                <b-form-group id="fieldset-2" label="Results Per Page" label-for="input-2">
                    <b-form-select id="input-2" v-model="perPage" :options="perPageOptions"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col class="my-1" cols="9" style="padding-top: 30px;">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>
    </div>
</template>
  
<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
// import * as _ from "lodash";
import { mapGetters } from 'vuex';
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
  
export default {
mixins: [
    DashboardBaseTemplate,
],
components: {},
props: {},
data: function() {
    return {
        showModal: false,
        ModalMessage: '',
        // sortBy: "id",
        // sortDesc: false,
        tableData: [],
        fields: [
            { key: 'id', label: 'Row ID' },  // Adding "id" for help with coordinating fixes for data entry...
            { key: 'household_id', label: 'Household ID' },
            { key: 'new_product_bag_barcode', label: 'New Product Bag Barcode' },
            { key: 'used_product_bag_barcode', label: 'Used Product Bag Barcode' },
            { key: 'placement_type', label: 'Placement Type' },
            { key: 'products_required', label: 'Products Required' },
            { key: 'percent_used', label: 'Percent Used' },
            { key: 'missing_product_count', label: 'Missing Product Count' },
            { key: 'mismatched_product_count', label: 'Mismatched Product Count' },
            { key: 'unused_product_count', label: 'Unused Product Count' },
            { key: 'new_product_barcodes', label: 'New Product Barcodes' },
            { key: 'unused_product_barcodes', label: 'Unused Product Barcodes' },
            { key: 'placed_product_barcodes', label: 'Placed Product Barcodes' },
            { key: 'used_product_barcodes', label: 'Used Product Barcodes (Prev. Placement)' },
            { key: 'missing_product_barcodes', label: 'Missing Product Barcodes (Prev. Placement)' },
            { key: 'mismatched_product_barcodes', label: 'Mismatched Product Barcodes (Prev. Placement)' },
            { key: 'prepared_date', label: 'Prepared Date' },
            { key: 'returned_date', label: 'Returned Date'}
        ],
        start_date: '',
        end_date: '',
        search_keyword: null,
        // fields: [],
        totalRows: 0,
        currentPage: 1,
        perPage: 20,
        title: "",
        perPageOptions: [
            10,
            15,
            20,
            25,
            50
        ],
        tableBusy: false,
        fileDownload: false,
        csvLoading: false
    };
},
computed: {
    // ...mapState("user", ["user", "myGroups"]),
    ...mapGetters("user", ["inMyGroups"]),
},
watch: {
    // search_keyword: function(){
    //     this.updateTable();
    // },
    start_date: function(){
        this.updateTable();
    },
    end_date: function(){
        this.updateTable();
    }
},
created: function() {},
mounted: function() {},
methods: {
    buildRequestParams () {
        let that = this;
        var params = new URLSearchParams();
        if(that.search_keyword && that.search_keyword != ''){
            params.append('search_keyword', that.search_keyword);
        }
        if(that.start_date && that.start_date != ''){
            params.append('start_date', that.start_date);
        }
        if(that.end_date && that.end_date != ''){
            params.append('end_date', that.end_date);
        }
        return params;
    },
    getData: function(ctx) {
        let that = this;

        var params = that.buildRequestParams();
        params.append("current_page", ctx.currentPage);
        params.append("per_page", ctx.perPage);
        // params.append("sort_by", ctx.sortBy);
        // params.append("descending", ctx.sortDesc);

        return HTTP.get("srilanka/product_bag/list/", {params: params})
            .then((response) => {
            that.tableData = response.data.row_data;
            that.totalRows = response.data.totalRows;
            return that.tableData;
        })
        .catch((error) => {
            HandleErrors.HandleErrors(error);
        });
    },
    downloadFile: function(){
        let that = this;
        var params = that.buildRequestParams();
        
        console.log("Starting CSV download with params:", params.toString());
        that.csvLoading = true;

        // Build the direct download URL like Analysis.vue does
        let downloadUrl = `${process.env.VUE_APP_AXIOS_BASE_URL}/srilanka/product_bag/list/?return_as=csv`;
        
        // Add the search parameters
        if (params.get('search_keyword')) {
            downloadUrl += `&search_keyword=${encodeURIComponent(params.get('search_keyword'))}`;
        }
        if (params.get('start_date')) {
            downloadUrl += `&start_date=${params.get('start_date')}`;
        }
        if (params.get('end_date')) {
            downloadUrl += `&end_date=${params.get('end_date')}`;
        }

        console.log("Download URL:", downloadUrl);

        // Use the same approach as Analysis.vue
        HTTP.get(downloadUrl, {
            responseType: 'blob',
            timeout: 600000, // 10 minute timeout for very large datasets
        }).then((response) => {
            console.log("CSV Download Response:", response);
            console.log("Response data type:", typeof response.data);
            console.log("Response data length:", response.data ? response.data.length : 'undefined');
            
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "ProductBagStatusExport.csv");
            document.body.appendChild(fileLink);
            fileLink.click();
            
            // Clean up
            document.body.removeChild(fileLink);
            window.URL.revokeObjectURL(fileURL);
            that.csvLoading = false;
        }).catch((error) => {
            console.error("CSV Download Error:", error);
            console.error("Error details:", error.response ? error.response.data : 'No response data');
            that.csvLoading = false;
            HandleErrors.HandleErrors(error);
        });
    },
    updateTable: function(){
      this.$refs.resultTable.refresh();
    },
    clearFields() {
        this.search_keyword = '';
        this.start_date = '';
        this.end_date = '';
    },
    onRowSelected(items) {
        if(this.inMyGroups(['Product Bag Manager'])) {
            this.$router.push({name: 'product-bag-edit', params: {id: items[0]['id'] }});
        } else {
            console.log('Not authorized to edit product bags.')
        }
    },
}
};
</script>

<style scoped></style>
  